import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { niceDateFormatter } from '../../lib/helper/formatting';
import { isStaff } from '../../lib/helper/authorisation';
import { renderField } from '../../lib/helper/form';
import { Field, reduxForm } from 'redux-form';
import Form from 'react-bootstrap/Form';
import ConsultantTypeahead from '../fields/ConsultantTypeahead';
import { downloadInvoiceRevisitByDayInvoiceCountsExport } from '../../lib/helper/downloadHelper';
import { addToast } from '../../lib/redux/actions/toast';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { getInvoiceRevisitByDayCounts } from '../../lib/redux/actions/invoiceRevisitByDayCounts';

const moment = extendMoment(Moment);

const mapStateToProps = (state) => ({
  ...state.invoiceRevisitsByDayCounts,
  ...state.auth,
  initialValues: {
    fromDate: moment(moment()).format('YYYY-MM-DD'),
    toDate: moment(moment()).add('+10', 'days').format('YYYY-MM-DD'),
  },
});

const mapDispatchToProps = {
  getInvoiceRevisitByDayCounts,
  addToast,
};

class InvoiceRevisitByDay extends React.Component {
  constructor(props) {
    super(props);

    const { initialize, initialValues } = this.props;

    this.state = {
      selectedConsultant: false,
      clearTypeaheads: false,
      fromDate: moment(moment()).format('YYYY-MM-DD'),
      toDate: moment(moment()).add('+10', 'days').format('YYYY-MM-DD'),
      triggerExport: false,
    };

    initialize(initialValues);
  }

  componentDidMount() {
    this.loadInvoiceRevisitByDayCounts();
  }

  loadInvoiceRevisitByDayCounts() {
    const { consultant = false } = this.props;

    const filters = {};
    if (consultant !== false) {
      filters.consultant = consultant['@id'];
    }

    this.props.getInvoiceRevisitByDayCounts(filters);
  }

  onSubmit() {
    const { consultant, getInvoiceRevisitByDayCounts } = this.props;

    if (consultant) {
      return;
    }

    const filters = {};
    if (this.state.selectedConsultant) {
      filters.consultant = this.state.selectedConsultant.map((c) => c['@id']);
      filters.consultant = filters.consultant[0];
    }
    if (this.state.fromDate) {
      filters.from_date = this.state.fromDate;
    }
    if (this.state.toDate) {
      filters.to_date = this.state.toDate;
    }
    getInvoiceRevisitByDayCounts(filters);
    if (this.state.triggerExport === true) {
      return downloadInvoiceRevisitByDayInvoiceCountsExport(
        filters,
        `INVOICE_REVISIT_BY_DAY_COUNTS_${niceDateFormatter(moment.utc(this.state.fromDate))}-${niceDateFormatter(moment.utc(this.state.toDate))}.csv`,
      ).catch(() => {
        addToast('There was a problem downloading the file. Please seek support if the issue continues.', false);
      });
    }
  }

  resetFilters() {
    const { initialize, initialValues } = this.props;

    this.clearTypeaheads();
    this.setState(() => ({
      selectedConsultant: [],
      fromDate: moment(moment()).format('YYYY-MM-DD'),
      toDate: moment(moment()).add('+10', 'days').format('YYYY-MM-DD'),
    }));

    initialize(initialValues);

    this.props.getInvoiceRevisitByDayCounts();
  }

  clearTypeaheads() {
    this.setState(() => {
      return { clearTypeaheads: true };
    });
  }

  typeaheadCleared() {
    if (this.state.clearTypeaheads) {
      this.setState(() => {
        return { clearTypeaheads: false };
      });
    }
  }

  render() {
    const { handleSubmit, showFilters = true, invoiceRevisitsByDayCounts } = this.props;
    return (
      <>
        {isStaff() && showFilters && (
          <div>
            <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="form-inline form-data-filters">
              <ConsultantTypeahead
                shouldClear={this.state.clearTypeaheads}
                hasCleared={this.typeaheadCleared.bind(this)}
                multiple={false}
                onChange={(selected) => {
                  this.setState(() => {
                    return { selectedConsultant: selected };
                  });
                }}
              />
              <Field
                name="fromDate"
                label="From Date"
                type="date"
                onChange={(event) => {
                  this.setState(() => {
                    return { fromDate: event.target.value };
                  });
                }}
                value={this.state.fromDate}
                component={renderField}
              />

              <Field
                name="toDate"
                label="To Date"
                type="date"
                onChange={(event) => {
                  this.setState(() => {
                    return { toDate: event.target.value };
                  });
                }}
                value={this.state.toDate}
                component={renderField}
              />

              <div className="filter-actions">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    this.setState(() => {
                      return { triggerExport: false };
                    });
                  }}>
                  Filter
                </button>
                <button type="button" className="btn btn-outline-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
                  Reset
                </button>
                <button
                  type="submit"
                  className="btn btn-secondary btn-sm ml-2"
                  onClick={() => {
                    this.setState(() => {
                      return { triggerExport: true };
                    });
                  }}
                  name="export">
                  Export
                </button>
              </div>
            </Form>
          </div>
        )}
        <div className="dashboard-chart-wrapper">
          {Object.keys(invoiceRevisitsByDayCounts).length ? (
            <>
              <table className="charts-css column show-heading show-labels show-primary-axis show-10-secondary-axes show-data-axes data-spacing-5">
                <thead>
                  <tr>
                    <th scope="col">Day</th>
                    <th scope="col">Number of Invoices</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(invoiceRevisitsByDayCounts).map((invoiceRevisits) => {
                    let highestValue = Math.max(...Object.values(invoiceRevisitsByDayCounts).map((ir) => ir.Count));
                    return (
                      <tr key={invoiceRevisits[0]}>
                        <th scope="row">{niceDateFormatter(invoiceRevisits[0], 'DD/MM')}</th>
                        <td
                          className="revisit-bar"
                          style={{ '--size': invoiceRevisits[1].Count / highestValue }}
                        >
                          <Link
                            to={`/invoices?revisitDate=${invoiceRevisits[0]}`}
                            className="revisit-bar-link"
                          >
                            <span className="data">{invoiceRevisits[1].Count}</span>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ) : (
            <p>No Invoices found</p>
          )}
        </div>
      </>
    );
  }
}

export default reduxForm({
  form: 'InvoiceRevisitByDayCounts',
  enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(InvoiceRevisitByDay));
